import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// Initialize dayjs with UTC plugin
dayjs.extend(utc);

export const generateAuthenticationDetails = () => {
  // Get current time in UTC
  const now = dayjs().utc();

  // Extract date components in UTC
  const year = now.year();
  const date = now.date();
  const hour = now.hour();
  const minute = now.minute();
  const second = now.second();

  // Generate timestamp in milliseconds (UTC)
  const timestamp = now.valueOf();

  // Generate security code using UTC values
  const securityCode =
    year * second + date * 5 + hour * 15 + minute * second + second * 3;

  return { timestamp, securityCode };
};
